document.addEventListener("DOMContentLoaded", function () {

    const slides = document.querySelectorAll(".why-map-slide");
    const progressFill = document.getElementById("why-map-progress-fill");

    if (!slides.length) return;

    let current = 0;

    function updateProgress() {

    const progressFill = document.getElementById("why-map-progress-fill");

    if (!progressFill) return;

    const totalSlides = slides.length;

    const percent = ((current + 1) / totalSlides) * 100;

    progressFill.style.width = percent + "%";

}

    function showSlide(index) {

    slides.forEach(function(slide){

        slide.classList.remove("active");

    });

    slides[index].classList.add("active");

    current = index;

    updateProgress();

}
function calculateWhyMap() {

    // Collect all answers
    const answers = {};

    document.querySelectorAll(".why-map-slide").forEach(function (slide) {

        const select = slide.querySelector("select");

        if (select) {
            answers[select.name] = String(select.value).trim();
        }

    });

  
    // Safety check
    if (!window.whyRules || !Array.isArray(window.whyRules)) {
        console.error("whyRules not available");
        return;
    }

    const matchedRules = [];

    window.whyRules.forEach(function (rule, index) {

        const answer = String(
            answers[rule.question_id] || ""
        ).trim().toLowerCase();

        const option = String(
            rule.option || ""
        ).trim().toLowerCase();

     
        if (answer === option) {

            console.log("✅ MATCH FOUND");

            matchedRules.push(rule);

        }

    });

      matchedRules.sort(function(a, b){

    return b.impact_score - a.impact_score;

});

    // ------------------------------------
// SORT RULES BY IMPACT SCORE
// ------------------------------------

matchedRules.sort(function(a, b){

    return Number(b.impact_score) - Number(a.impact_score);

});


    // ------------------------------------
// FIND MATCHING INSIGHTS
// ------------------------------------

const matchedInsights = [];

const topRules = matchedRules.slice(0,3);

topRules.forEach(function(rule){

    const insight = window.whyInsights.find(function(item){

        return item.insight_id === rule.insight_id;

    });

    if(insight){

        matchedInsights.push(insight);

    }

});


// ----------------------------
// Store first matched insight
// ----------------------------

window.currentInsight = matchedInsights[0] || null;

// -------------------------------------
// HIDE ALL INSIGHT CARDS
// -------------------------------------

document.querySelectorAll(".why-insight-card").forEach(function(card){

    card.style.display = "none";

});



// -------------------------------------
// SHOW MATCHED INSIGHTS
// -------------------------------------

matchedInsights.forEach(function(insight){

    const card = document.querySelector(
        '.why-insight-card[data-insight-id="' +
        insight.insight_id +
        '"]'
    );



    if(card){

        card.style.display = "block";

    }

});
// Store the primary insight for the tabs
// -------------------------------------
// Populate Learn Panel
// -------------------------------------

if(window.currentInsight){

    document.getElementById("why-learn-title").textContent =
        window.currentInsight.knowledge_page.title;

    document.getElementById("why-learn-button").href =
        window.currentInsight.knowledge_page.url;

}
// -------------------------------------
// Populate Tool Panel
// -------------------------------------

if(window.currentInsight){

    document.getElementById("why-tool-title").textContent =
        window.currentInsight.tool.title;

    document.getElementById("why-tool-button").href =
        window.currentInsight.tool.url;

}
// -------------------------------------
// Populate Product Panel
// -------------------------------------

if(window.currentInsight){

    document.getElementById("why-product-title").textContent =
        window.currentInsight.product.title;

    document.getElementById("why-product-button").href =
        window.currentInsight.product.url;

}




document.querySelector(".why-map-assessment-panel").style.display = "none";

document.querySelector(".why-map-result-panel").style.display = "block";


}
    showSlide(0);

    document.addEventListener("click", function (e) {

        if (e.target.classList.contains("why-next")) {

            e.preventDefault();

            const select = slides[current].querySelector("select");

            if (!select.value) {
                alert("Please select an option.");
                return;
            }

            if (current < slides.length - 1) {

                current++;
                showSlide(current);

            }

        }

        if (e.target.classList.contains("why-prev")) {

            e.preventDefault();

            if (current > 0) {

                current--;
                showSlide(current);

            }

        }

    });
document.querySelector(".why-generate").addEventListener("click", function(e){

    e.preventDefault();

    calculateWhyMap();

});
// -----------------------------
// Result Tabs
// -----------------------------

// -----------------------------
// WHY MAP TABS
// -----------------------------

document.querySelectorAll(".why-tab").forEach(function(tab){

    tab.addEventListener("click", function(e){

        e.preventDefault();

        // ------------------------
        // Active Tab
        // ------------------------

        document.querySelectorAll(".why-tab").forEach(function(btn){

            btn.classList.remove("active");

        });

        this.classList.add("active");

        // ------------------------
        // Active Panel
        // ------------------------

        document.querySelectorAll(".why-tab-panel").forEach(function(panel){

            panel.classList.remove("active");

        });

        const tabName = this.dataset.tab;

        const activePanel = document.getElementById(tabName);

        if(activePanel){

            activePanel.classList.add("active");

        }

    });

});
});